import { ArchiveEyeIcon } from './ArchiveEyeIcon';

/**
 * author: Colton Wiscombe
 * id 82B3AAAD-92D1-4524-98F4-F29AFB1A5BFA
 * name archive-eye
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-eye.svg
 * tags
 */
export const BoxEyeIcon = ArchiveEyeIcon;
export default BoxEyeIcon